<app-loader [isLoading]="isLoading"></app-loader>

<div class="doc-uoload-details">
    <div class="title">
        <div class="close-button invisible"></div>
        <span class="title-txt">Upload Document</span>
        <div class="close-button" (click)="closeDialog()">
            <mat-icon class="close-icon close">close</mat-icon>
        </div>
    </div>
    <div class="modal-picture-container">
        @if (!file) {
        <button class="dp-secondary-btn img-btn" (click)="uploadDoc()">Upload</button>
        }@else {
            <img *ngIf="imagePreview" [src]="imagePreview" alt="image" class="img-view">
            <button class="dp-secondary-btn img-btn" (click)="uploadDoc()">Retake</button>
        }
    </div>
    <div class="details">
        <div class="each-detail">
            <span class="common-title">Add Comment</span>
            <textarea class="notes" [(ngModel)]="comments" placeholder="Add Comment(optional)"></textarea>

        </div>
    </div>
    <div class="btn-div">
        <button class="dp-secondary-btn second-btn" (click)="closeDialog()">Close</button>
        <button class="dp-primary-btn second-btn" (click)="submitdocx()">Submit</button>
    </div>
</div>